<template>
  <div>
    <div v-if="staffList.length" class="coach-page">
      <div v-for="(item, index) in staffList" :key="index" class="item">
        <img :src="imageSrc(item.img)" class="coach-img" alt="staff-img">
        <ul :class="{first : index === 3}">
          <li>
            <p class="name">{{item.koNm}}</p>
            <p class="sub" :class="{paddingLeft: item.img === 'staff_09'}">{{item.engNm}}</p>
          </li>
          <li>
            <p>{{item.position}}</p>
            <p>{{item.birthday}}</p>
            <p v-html="htmlConverter(item.education)" style="white-space: pre-line;"></p>
          </li>
        </ul>
      </div>
    </div>
    <div v-else class="empty-div">
      데이터가 없습니다.
    </div>
  </div>
</template>

<script>
import staff from '@/components/Player/Json/staff'
import {htmlConverter} from '@/lib';
export default {
  name: 'Staff',
  data() {
    return {
      staffList: [],
    }
  },
  mounted () {
    this.getStaffList();
  },
  methods: {
    htmlConverter,
    getStaffList() {
      this.staffList = staff;
    },
    imageSrc(imgSrc) {
      return require('@/assets/img/player/staff/'+imgSrc+'.png');
    },
  }
}
</script>
<style scoped>
.paddingLeft {
  width: 100px;
}

.coach-page .item ul.first {
  padding: 60px 28px 68px 45px;
}

@media (max-width: 959px) {
  .coach-page .item ul.first {
    padding: 24px 0 0 31px;
  }
}
</style>
